import { useQuery } from '@tanstack/react-query';

import { readMeWithAdminAccess } from './readMeWithAdminAccess.ts';

export const useLoggedInUserQuery = () =>
  useQuery({
    queryKey: ['logged-in-user'],
    queryFn: readMeWithAdminAccess,
    retry: 0,
  });
